/* src/app/account-executive/account-executive.component.css */
body {
  background-color: #f2f2f2;
  color: #000000;
}
.input-ErrorField {
  font-size: 12px;
  padding-bottom: 0px;
  margin-bottom: 13px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #cc0000;
  background: transparent;
  position: relative;
  float: right;
  font-family: Helvetica;
}
.fixed-size {
  width: 1823px;
  display: inline-block;
}
.container-hide {
  visibility: hidden;
}
.container-unhide {
  visibility: visible;
}
.refund-hide {
  display: none;
}
.refund-unhide {
  display: visible;
}
.header_bg {
  background: url(/assets/images/ots_bg.png) no-repeat center top;
  text-align: center;
  background-size: cover;
}
.logo {
  text-align: left;
  color: #fff;
  padding: 12px 0px 0px 25px;
}
.user_main {
  float: right;
  text-align: right;
  color: white;
  border-left: solid 1px rgba(0, 0, 0, 0.2);
  padding: 30px 30px 30px 0px;
}
.user_main p {
  float: right;
  padding-right: 10px;
}
.user_icon {
  float: right;
  background-color: #008ad0;
  padding: 8px;
  border-radius: 30px;
  font-size: 20px;
}
.blw_headermain {
  text-align: left;
  color: #fff;
  padding: 10px 15px 0px 15px;
}
.blw_headermain img {
  float: left;
  padding-right: 10px;
}
.blw_headermain p {
  color: #2a2a2a;
  opacity: 0.8;
}
.round_table {
  border-radius: 20px;
  width: 100%;
  overflow-x: scroll;
  font-size: 12px;
}
.round_table {
  border-collapse: separate;
  border-spacing: 0;
}
.round_table tr {
  border: 1px solid #d6d6d6;
  border-radius: 20px;
  -moz-border-radius: 20px;
  -o-border-radius: 20px;
  -webkit-border-radius: 10px;
}
.transaction_table tr {
  border-bottom: 1px solid rgb(197, 197, 197);
  border-collapse: collapse;
}
.round_table td {
  border-bottom: 1px solid #d6d6d6;
  background-color: #ffffff;
}
.round_table tbody tr th:nth-child(1) {
  padding-left: 20px;
}
.round_table tbody tr td:nth-child(1) {
  padding-left: 20px;
}
.round_table tbody tr td:last-child {
  width: 115px;
}
.payment {
  width: 65px;
  float: left;
}
.transaction_main {
  margin-top: 10px;
}
.tab-content > .active {
  display: block;
  padding-top: 10px !important;
}
.userbtn_main {
  margin-top: -50px;
  position: absolute;
  right: -203px;
}
.download_report {
  background-color: #00adcc !important;
  padding: 0px 10px;
  border-radius: 30px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
  margin-left: 14px;
}
.download_report span {
  font-size: 20px;
  vertical-align: text-bottom;
}
.transaction_btn {
  background-color: #028ba3 !important;
  padding: 0px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.transaction_btn img {
  float: none;
  padding: 0px;
}
.round_table tbody tr th {
  border-bottom: 1px solid #d6d6d6;
}
#exTab1 .tab-content {
  color: #000000;
  padding: 0px;
  border-radius: 10px;
  clear: both;
}
#exTab1 .nav-pills > li > a {
  border-radius: 0;
}
td,
th {
  padding: 10px 5px;
  display: table-cell;
  text-align: left;
  vertical-align: middle;
  border-radius: 2px;
}
.nav_main {
  float: left;
  background-color: #ffffff;
  border-radius: 30px;
  border: 1px solid #cccccc;
  margin-bottom: 15px;
}
.nav-pills > li > a {
  border-radius: 30px !important;
  color: #000000;
  padding: 10px 36px;
}
.nav-pills > li > a:hover {
  background-color: #ffffff !important;
}
.nav-pills > li.active > a {
  color: #fff;
  background-color: #003992 !important;
}
.recent_dropdown {
  position: absolute;
  right: 723px !important;
  top: 34px;
}
.btn:hover {
  background: transparent;
  color: #000;
  cursor: pointer;
}
.select_icon {
  background: transparent;
  color: #000000;
  border: 1px solid #01adcc;
  border-radius: 30px;
  text-transform: unset;
  padding: 0px 18px !important;
}
.dropdown-menu {
  right: 15px;
  left: auto;
  border-radius: 0px;
  padding: 0px;
  border: 1px solid #e4e4e4;
  cursor: pointer;
}
.dropdown-menu > li > a {
  display: block;
  padding: 15px 100px 15px 10px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  border-bottom: 1px solid #e0e0e0;
}
.drop_downicon {
  color: #ffffff;
  position: absolute;
  right: 13px;
  top: -24px;
  font-size: 30px;
}
.btn-primary.active,
.btn-primary:active,
.open > .dropdown-toggle.btn-primary {
  color: #000 !important;
  background-color: transparent !important;
  border-color: #01adcc !important;
}
.add_refund {
  background-color: #30a740;
  color: #ffffff;
  padding: 0px 5px;
  line-height: 0px;
  height: 26px;
  text-transform: capitalize;
  font-size: 14px;
}
.add_refund:hover {
  background-color: #30a740;
  color: #ffffff;
}
.modal-header {
  padding: 10px;
  border-bottom: 1px solid #e5e5e5;
  background:
    linear-gradient(
      to right,
      #00569b,
      #00d1e1);
  color: #fff;
  border-radius: 5px 5px 0px 0px;
}
.modal-header .close {
  margin-top: -26px;
  opacity: 1;
  background-color: transparent;
  color: #fff;
}
.label_modifi {
  font-weight: normal;
  float: left;
  margin-top: 10px;
  margin-right: 10px;
  width: 140px;
}
.popupuser_icon {
  float: right;
  font-size: 20px;
  color: #444343;
}
.form_main {
  clear: both;
  margin-top: 20px;
}
.input_modifi {
  border: none;
  border-bottom: 1px solid #d0cccc;
  border-radius: 0px !important;
  outline: none !important;
  box-shadow: none !important;
  margin-top: 0px;
  padding: 0px;
}
.transaction_id {
  width: 130px;
  float: left;
}
.add_on {
  background: transparent;
  border: none;
  border-bottom: 1px solid #d8d8d8;
  border-radius: 0px;
}
.dollar_icon {
  float: right;
  font-size: 20px;
  color: #444343;
  margin: -20px;
}
.buttons_main {
  text-align: center;
}
.submit_popup {
  background-color: #30a740;
  border: none;
  border-radius: 30px;
  padding: 5px 18px;
}
.cancel_popup {
  background-color: #d9534f;
  border: none;
  border-radius: 30px;
  padding: 5px 18px;
}
.submit_popup:hover {
  background-color: #30a740;
  color: #ffffff;
}
.cancel_popup:hover {
  background-color: #d9534f;
  color: #ffffff;
}
textarea {
  resize: none;
}
#refundComments {
  height: 60px;
}
#refundAmount {
  height: 30px;
}
.labelComment {
  margin-top: 0px !important;
}
.commentsWordWrap {
  width: 250px;
  white-space: normal;
  word-break: break-all;
}
.revisedRefund {
  background: #ff7e00 !important;
}
.noRecordTable {
  color: red;
}
@media (min-width: 300px) and (max-width: 600px) {
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #505050;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #b30000;
  }
  .download_report {
    padding: 0px 8px;
  }
  .select_icon {
    padding: 0px 12px !important;
  }
  .logo {
    text-align: left;
    color: #fff;
    padding: 25px 14px 0px 25px;
  }
  .user_main {
    float: right;
    text-align: right;
    color: white;
    border-left: solid 1px rgba(0, 0, 0, 0.2);
    padding: 15px 28px 7px 0px;
    margin-left: 0px;
  }
  .blw_headermain img {
    float: left;
    padding-bottom: 25px;
    padding-right: 10px;
  }
  .nav_main {
    float: left;
    background-color: #ffffff;
    border-radius: 30px;
    border: 1px solid #cccccc;
    margin-bottom: 20px;
  }
  .userbtn_main {
    margin: 0 0 20px 0 !important;
    position: static !important;
  }
  .add_internaluserbtn {
    margin-top: 10px;
  }
  .userbtn_main img {
    float: right;
    padding: 4px 0px 0px 4px;
  }
  .external_userlog_btn {
    background-color: #00adcc !important;
    padding: 0px 10px;
    border-radius: 20px;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: capitalize;
  }
  .external_add_internaluserbtn {
    background-color: #4eb700 !important;
    padding: 0px 10px;
    border-radius: 20px;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: capitalize;
    margin-top: 10px;
  }
  .external_userlog_btn img {
    float: none;
    padding: 0px !important;
  }
  .buttons_main {
    padding-left: 0px;
  }
}
@media (min-width: 600px) and (max-width: 900px) {
  .userbtn_main {
    margin-top: -65px;
    position: absolute;
  }
  .external_add_internaluserbtn {
    margin-top: 0px;
  }
  .bulk_upload {
    margin-top: 0px;
  }
  .add_internaluserbtn {
    margin-top: 0px;
  }
}
.search_box {
  padding-right: 50px;
}
.search_icon {
  margin: 0;
  position: absolute;
  right: 0;
}
.searchmain .search_modified {
  margin: 30px;
  background-color: #028ba3 !important;
  padding: 8px 10px;
  color: #ffffff;
  position: absolute;
  right: -27px;
  height: 30px;
  box-sizing: border-box;
}
.searchmain .searchbox {
  width: 400px;
  display: inline-block;
  box-sizing: border-box;
  height: 30px;
  padding-right: 50px;
}
.searchmain .searchbox:focus {
  box-shadow: none;
}
.searchmain {
  margin: 0;
  position: relative;
  text-align: right;
}
#Comments {
  height: 60px;
}
.commentsadd_on {
  background: transparent;
  border: none;
  border-radius: 0px;
}
.cusCell {
  display: table-cell;
  vertical-align: middle !important;
}
.cusTable {
  display: table;
}
.ui-calendar {
  height: 63% !important;
  width: 2em;
}
.datesearch {
  background-color: #00adcc !important;
  padding: 0px 10px;
  border-radius: 30px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
  width: 130px;
  margin-left: 20px;
}
.submittransaction {
  background-color: #00adcc !important;
  padding: 0px 10px;
  border-radius: 30px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
  width: 146px;
  margin-left: -7px;
}
.col-lg-3 {
  width: 15% !important;
}
.datesearch {
  padding: 0px 8px;
}
.datesearch span {
  font-size: 20px;
  vertical-align: text-bottom;
}
.container-hide {
  visibility: hidden;
}
.container-unhide {
  visibility: visible;
}
.col-lg-2 {
  width: 17.666667% !important;
}
.submit_btn {
  background-color: #009f16 !important;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.btnSubmit {
  border-radius: 30px;
  background: #009f16 !important;
  text-transform: capitalize;
  box-shadow: none;
  padding: 0px 18px 0px 11px;
  margin-bottom: 15px;
}
.checkbox td {
  width: 20px;
}
[type=checkbox]:not(:checked),
[type=checkbox]:checked {
  position: absolute;
  left: 0px;
  opacity: 1;
}
.checkbox input[type=checkbox],
.checkbox-inline input[type=checkbox],
.radio input[type=radio],
.radio-inline input[type=radio] {
  margin-left: 0px;
  font-size: 20px;
}
.checkbox_main {
  margin-left: 1.5%;
  margin-top: 1% !important;
  position: relative;
  text-align: left;
}
.Show_transaction {
  font-size: 14px;
  float: left;
  margin: 0px 5px;
  color: #040404;
  margin-left: 17px;
}
.hide {
  display: none;
}
.calendar-margin {
  margin-left: 30% !important;
}
.calendar-margin-right {
  margin-left: 11px !important;
  margin-right: -4px !important;
}
.userbtn-width {
  width: 917px;
}
.searchbox-width {
  width: 35% !important;
}
.error-span-width {
  width: 65.5% !important;
}
.save-btn-padding {
  padding: 2px;
}
.table-style {
  max-width: 170px;
  word-break: break-all;
  overflow-wrap: break-word;
}
.p-calendar {
  display: inline-flex !important;
  align-items: center;
  white-space: nowrap;
}
::ng-deep .p-calendar {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
::ng-deep .p-calendar .p-inputtext {
  flex: 1 1 auto;
}
::ng-deep .p-calendar .p-datepicker-trigger {
  display: inline-flex;
  align-items: center;
}
.filters-container {
  margin-bottom: 15px;
}
.filters-container .btn,
.filters-container p-calendar,
.filters-container input {
  height: 38px;
}
.search-box input {
  width: 100%;
}
/*# sourceMappingURL=account-executive.component.css.map */
